import { getMessaging, onMessage } from 'firebase/messaging';

import { sentryLogger } from '@/adapters/logger/sentryLogger';
import { initializeFirebaseWeb } from '@/adapters/pushNotification/firebaseInitialization.web';
import type { ForegroundHandlerOptions } from '@/adapters/pushNotification/types';

const registerForegroundHandler = (options?: ForegroundHandlerOptions): (() => void) => {
  const app = initializeFirebaseWeb();
  const messaging = getMessaging(app);

  return onMessage(messaging, (payload) => {
    options?.onMessageReceived?.();
    sentryLogger.addBreadcrumb('Foreground FCM message received on web', {
      messageId: payload.messageId,
    });

    const title = payload.notification?.title;
    const body = payload.notification?.body;
    const icon = payload.notification?.icon;

    if (!title && !body) {
      return;
    }

    const notification = new Notification(title || 'Notification', {
      body: body ?? undefined,
      icon: icon ?? undefined,
      tag: payload.messageId,
      data: payload.data,
    });

    notification.onclick = () => {
      window.focus();
      notification.close();

      const contactId = payload.data?.['contact_id'];
      if (contactId) {
        window.location.href = `/contact/${contactId}`;
      }
    };
  });
};

export { registerForegroundHandler };
